import { useSelector, useDispatch } from 'react-redux'
import { RootState } from '../reducers/rootReducer';

import { SET_IMAGE, SET_FORMAT, SET_DIMENSION, SET_POSITION, SET_AVIABLE, SET_IS_CHANGED, SET_ROTATED } from '../constants/canvasConstants';

export default function CanvasActions() {
   const dispatch = useDispatch();

   const image = useSelector((state: RootState) => state.canvasReducer.image);
   const format = useSelector((state: RootState) => state.canvasReducer.format);
   const width = useSelector((state: RootState) => state.canvasReducer.width);
   const height = useSelector((state: RootState) => state.canvasReducer.height);
   const positionX = useSelector((state: RootState) => state.canvasReducer.x);
   const positionY = useSelector((state: RootState) => state.canvasReducer.y);
   const isAvaible = useSelector((state: RootState) => state.canvasReducer.isAvaible);
   const isChanged = useSelector((state: RootState) => state.canvasReducer.isChanged);
   const rotationAngle = useSelector((state: RootState) => state.canvasReducer.rotationAngle);

   const setAvaible: Function = (isAvaible = true) => {
      dispatch({ type: SET_AVIABLE, isAvaible: isAvaible });
   }

   const setImage: Function = (image: File) => {
      dispatch({ type: SET_IMAGE, image: URL.createObjectURL(image) });
   }

   const changeImage: Function = (image: string) => {
      dispatch({ type: SET_IMAGE, image: image });
   }

   const setFormat: Function = (format: string) => {
      dispatch({ type: SET_FORMAT, format: format });
   }

   const setDimension: Function = (height: number, width: number) => {
         dispatch({ type: SET_DIMENSION, height: height, width: width });
   }  

   const setPosition: Function = (positionX, positionY) => {
      dispatch({ type: SET_POSITION, x: positionX, y: positionY });
   }

   const setChanged: Function = () => {
      dispatch({ type: SET_IS_CHANGED, isChanged: true });
   }

   const setRotationAngle: Function = (rotationAngle: number) => {
      dispatch({ type: SET_ROTATED, rotationAngle: rotationAngle });
   }

   const clear: Function = () => {
      dispatch({ type: SET_IMAGE, image: '' });
      dispatch({ type: SET_FORMAT, format: 'image/jpeg' });
      dispatch({ type: SET_DIMENSION, height: 0, width: 0 });
      dispatch({ type: SET_POSITION, x: 0, y: 0 });
      dispatch({ type: SET_IS_CHANGED, isChanged: false });
      dispatch({ type: SET_ROTATED, rotationAngle: 0 });
      
      dispatch({ type: "CANVAS_SET_FLIP_VERTICAL", isFlipVertical: false});
      dispatch({ type: "CANVAS_SET_FLIP_HORIZONTAL", isHorizontal: false });
   }

   return {
      canvasImage: image,
      canvasFormat: format,
      canvasWidth: width,
      canvasHeight: height,
      canvasPositionX: positionX,
      canvasPositionY: positionY,
      canvasIsAvaible: isAvaible,
      canvasIsChanged: isChanged,
      canvasRotationAngle: rotationAngle,
      setImage: setImage,
      setFormat: setFormat,
      canvasSetDimension: setDimension,
      setPosition: setPosition,
      canvasClear: clear,
      changeImage: changeImage,
      canvasSetAviable: setAvaible,
      canasSetChanged: setChanged,
      canvasSetRotationAngle: setRotationAngle 
   }
}

